// @flow

const styles = {
  appBar: (theme) => ({
    boxShadow: 'none',
    marginLeft: theme.layout.customProps.drawer.width,
    zIndex: theme.zIndex.drawer + 1,
    [theme.breakpoints.up('sm')]: {
      width: `calc(100% - ${theme.layout.customProps.drawer.width}px + 1px)`
    }
  }),
  
  toolbar: (theme) => ({
    paddingLeft: 0,
    paddingRight: 0,
    minHeight: theme.layout.customProps.toolbar.height || 56,
    display: 'flex',
    flexDirection: 'column'
  }),
  
  pageTitle: (theme) => ({
    marginRight: theme.spacing(4),
    color: 'white',
    textShadow: '0px 0 4px hsl(0deg 0% 0% / 12%)',
    '&.light': {
      color: theme.palette.primary.main,
      background: 'white'
    },
    '& a': {
      textDecoration: 'none',
      color: 'inherit'
    },
    [theme.breakpoints.down('sm')]: {
      whiteSpace: 'nowrap',
      overflowX: 'scroll',
      maxWidth: '40vw'
    }
  }),
  
  rowSub: (theme) => ({
    ...theme.mixins.toolbar,
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    height: theme.layout.customProps.toolbar.height,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    }
  }),
  
  rowSubTypoCtr: () => ({
    alignItems: 'center'
  }),
  
  bottomBar: (theme) => ({
    background: theme.palette.primary.lighter,
    color: theme.palette.primary.light,
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    },
    [theme.breakpoints.down('xs')]: {
      marginLeft: -theme.spacing(1),
      width: `calc(100% + ${theme.spacing(1)}px)`
    }
  }),
  
  subHeaderCaption: () => ({
    fontSize: '1.1rem'
  }),
  
  grow: () => ({
    flexGrow: 1
  }),
  
  toggleContainer: (theme) => ({
    height: theme.layout.customProps.toolbar.height,
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    margin: 0,
    background: 'transparent',
    '& *': {
      display: 'flex',
      flexDirection: 'column',
      color: 'white',
      fontSize: '0.9rem',
      textDecoration: 'none'
    },
    '& i': {
      height: 28,
      fontSize: '1.6rem',
      filter: 'drop-shadow( 2px 1px 2px rgba(0, 0, 0, .1))'
    },
    '& svg': {
      height: 28,
      fontSize: '1.8rem',
      filter: 'drop-shadow( 2px 1px 2px rgba(0, 0, 0, .1))'
    }
  }),
  
  navButton: (theme) => ({
    height: theme.layout.customProps.toolbar.height,
    minWidth: theme.layout.customProps.toolbar.height,
    textTransform: 'none',
    textShadow: '0px 0 4px hsl(0deg 0% 0% / 12%)',
    padding: `10px ${theme.spacing(1)} 0 ${theme.spacing(1)}`,
    borderRadius: 0,
    color: 'white',
    '& *': {
      whiteSpace: 'nowrap'
    }
  }),

  navButtonActive: (theme) => ({
    height: theme.layout.customProps.toolbar.height,
    minWidth: theme.layout.customProps.toolbar.height,
    textTransform: 'none',
    textShadow: '0px 0 4px hsl(0deg 0% 0% / 12%)',
    padding: `10px ${theme.spacing(1)} 0 ${theme.spacing(1)}`,
    borderRadius: 0,
    color: 'white',
    backgroundColor: 'rgba(255, 255, 255, 0.15)', // Light overlay for active state
    '& *': {
      whiteSpace: 'nowrap'
    },
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.25)'
    }
  }),
  
  customerSearchBox: (theme) => ({
    border: 0,
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: 200,
      '&.first': {
        marginLeft: 0
      }
    }
  })
};

export default styles; 